import useSWR from 'swr';

import { FamilyPlanParams } from '@/components/familyPlan/FamilyPlanLanding/types';
import { User } from '@/store/user/types';

import { useApi } from '../api';

export function useCreateInviteLink(user: User | null, familyId?: string) {
	const apiRequest = useApi();

	const familyPlanId = user?.subscription?.family_details?.family_id ?? familyId;

	const { data, isLoading, error } = useSWR<{ family_invite_link: string | null }>(
		familyPlanId ? `familyplan/${familyPlanId}/invite` : null,
		async (endpoint: string) => {
			if (!endpoint) {
				return { family_invite_link: null };
			}

			const response = await apiRequest<{ family_invite_link: string | null }>({
				endpoint,
				method: 'GET',
			});
			return response.data;
		},
	);

	return {
		data: data?.family_invite_link,
		error,
		loading: isLoading,
	};
}

export function useGetInviteLinkHash(rawHash?: string, isUpdatedFlow?: boolean) {
	const apiRequest = useApi();

	return useSWR<FamilyPlanParams>(
		rawHash && isUpdatedFlow ? `/familyplan/${rawHash}/inviteValues` : null,
		async (endpoint: string) => {
			const response = await apiRequest<FamilyPlanParams>({
				endpoint,
				method: 'GET',
			});
			return response.data;
		},
	);
}
